import { TARGET_JUSO } from "./mutation_types";

export default {
  getCoCodeMap: state => state.coCodeMap,
  getCoCodeMapDetail: state => state.coCodeMapDetail,
  getTargetJuso: state => state.targetJuso,

  getAuthToken: state => state.authToken,
  getUserInfo: state => state.userInfo,
  getOwnerJuso: state => state.ownerJuso,
  getPropertyInquiry: state => state.propertyInquiry
};
